import { render } from "./AddonPrint.vue?vue&type=template&id=d1d08ff2&scoped=true"
import script from "./AddonPrint.vue?vue&type=script&lang=js"
export * from "./AddonPrint.vue?vue&type=script&lang=js"

import "./AddonPrint.vue?vue&type=style&index=0&id=d1d08ff2&scoped=true&lang=css"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1d08ff2"]])

export default __exports__